module.exports = __webpack_public_path__ + "img/jugems-cloud-glitch.f1fe0370.jpg";